import React from 'react';
import { MessageSquare, CalendarCheck, Sparkles } from 'lucide-react';
export function ProcessSection() {
  const steps = [{
    number: '01',
    icon: MessageSquare,
    title: 'Connect With Us',
    description: 'Fill out our free quote form or give us a call to share your outdoor lighting vision.'
  }, {
    number: '02',
    icon: CalendarCheck,
    title: 'Book Your Estimate',
    description: "We'll visit your property at a time that works for you to provide a personalized, in-person estimate."
  }, {
    number: '03',
    icon: Sparkles,
    title: 'Watch It Come to Life',
    description: 'After you approve the estimate, we schedule and complete the installation — exceeding your expectations.'
  }];
  return <section className="w-full bg-[var(--brand-soft-white)] py-20 lg:py-28" data-id="element-149">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-150">
        <div className="text-center mb-16 lg:mb-24" data-id="element-151">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[var(--brand-charcoal)] uppercase tracking-wider mb-4" data-id="element-152">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-153">
            Three simple steps to transform your outdoor space
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-8" data-id="element-154">
          {/* Connecting Line (Desktop Only) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gray-300 z-0" data-id="element-155"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-156">
              <div className="w-24 h-24 rounded-full bg-white shadow-lg flex items-center justify-center mb-6 border-4 border-[var(--brand-soft-white)]" data-id="element-157">
                <step.icon className="w-10 h-10 text-[var(--brand-gold)]" data-id="element-158" />
              </div>
              <div className="text-5xl font-bold text-[var(--brand-gold)] opacity-40 mb-4 font-mono" data-id="element-159">
                {step.number}
              </div>
              <h3 className="text-2xl font-bold text-[var(--brand-charcoal)] mb-4" data-id="element-160">
                {step.title}
              </h3>
              <p className="text-gray-600 text-base leading-relaxed max-w-sm" data-id="element-161">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}